/**
 * Consistent section header used across all tabs / panels.
 * (Spec mockup pattern: small uppercase header above a content block.)
 */
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function Section({
  title,
  children,
  className,
  action,
}: {
  title: ReactNode;
  children: ReactNode;
  className?: string;
  action?: ReactNode;
}) {
  return (
    <section className={cn('space-y-1.5', className)}>
      <header className="flex items-center justify-between">
        <h3 className="text-[0.615em] font-bold uppercase tracking-wider text-(--color-text3)">{title}</h3>
        {action}
      </header>
      {children}
    </section>
  );
}

export function SectionGroup({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('space-y-3', className)}>{children}</div>;
}
